




import {Component, Vue} from "vue-property-decorator";
import OriginatorRules from "@/pages/Pages/Rules/OriginatorRules.vue";
import {MsgTransports} from "@/store/types";

@Component({components: {OriginatorRules}})
export default class CallOriginatorRules extends Vue {
  private callTransport: MsgTransports = MsgTransports.CALL
}
